import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface SpectrumAnalysis {
  name: string
  currentCommentary: string
  aspirationalCommentary: string
  alignmentOpportunities: string
}

interface SpectrumSectionProps {
  spectra: SpectrumAnalysis[]
}

export function SpectrumSection({ spectra }: SpectrumSectionProps) {
  if (!spectra?.length) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle>Spectrum Analysis</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-8">
          {spectra.map((spectrum, index) => (
            <div key={spectrum.name} className="space-y-4">
              <h4 className="font-medium">{spectrum.name}</h4>
              <div className="grid gap-4 md:grid-cols-3">
                <div>
                  <p className="text-sm font-medium">Current State</p>
                  <p className="text-sm text-muted-foreground">{spectrum.currentCommentary}</p>
                </div>
                <div>
                  <p className="text-sm font-medium">Aspirational State</p>
                  <p className="text-sm text-muted-foreground">{spectrum.aspirationalCommentary}</p>
                </div>
                <div>
                  <p className="text-sm font-medium">Alignment Opportunities</p>
                  <p className="text-sm text-muted-foreground">{spectrum.alignmentOpportunities}</p>
                </div>
              </div>
              {index < spectra.length - 1 && <hr className="my-4" />}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}